/*!

=========================================================
* Argon Dashboard Chakra PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-chakra-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com/)

* Designed and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Assets
import avatar1 from "assets/img/avatars/avatar1.png";
import avatar10 from "assets/img/avatars/avatar10.png";
import avatar2 from "assets/img/avatars/avatar2.png";
import avatar3 from "assets/img/avatars/avatar3.png";
import avatar4 from "assets/img/avatars/avatar4.png";
import avatar5 from "assets/img/avatars/avatar5.png";
import avatar7 from "assets/img/avatars/avatar7.png";
import avatar8 from "assets/img/avatars/avatar8.png";
import avatar9 from "assets/img/avatars/avatar9.png";
// Custom icons
import {
  AdobexdLogo,
  AtlassianLogo,
  InvisionLogo,
  JiraLogo,
  SlackLogo,
  SpotifyLogo,
} from "components/Icons/Icons.js";
import { AiOutlineExclamation } from "react-icons/ai";
import {
  FaArrowDown,
  FaArrowUp,
  FaBell,
  FaCreditCard,
  FaFilePdf,
  FaHtml5,
  FaShoppingCart,
} from "react-icons/fa";
import { SiDropbox } from "react-icons/si";

export const dashboardTableData = [
  {
    logo: AdobexdLogo,
    name: "Argon UI Version",
    members: [avatar1, avatar2, avatar3, avatar4, avatar5],
    budget: "$14,000",
    progression: 60,
  },
  {
    logo: AtlassianLogo,
    name: "Add Progress Track",
    members: [avatar3, avatar2],
    budget: "$3,000",
    progression: 10,
  },
  {
    logo: SlackLogo,
    name: "Fix Platform Errors",
    members: [avatar10, avatar4],
    budget: "Not set",
    progression: 100,
  },
  {
    logo: SpotifyLogo,
    name: "Launch our Mobile App",
    members: [avatar2, avatar3, avatar7, avatar8],
    budget: "$32,000",
    progression: 100,
  },
  {
    logo: JiraLogo,
    name: "Add the New Pricing Page",
    members: [avatar10, avatar3, avatar7, avatar2, avatar8],
    budget: "$400",
    progression: 25,
  },
  {
    logo: InvisionLogo,
    name: "Redesign New Online Shop",
    members: [avatar9, avatar3, avatar2],
    budget: "$7,600",
    progression: 40,
  },
];

export const timelineData = [
  {
    logo: FaBell,
    title: "$2400, Design changes",
    date: "22 DEC 7:20 PM",
    color: "blue.500",
  },
  {
    logo: FaHtml5,
    title: "New order #4219423",
    date: "21 DEC 11:21 PM",
    color: "orange",
  },
  {
    logo: FaShoppingCart,
    title: "Server Payments for April",
    date: "21 DEC 9:28 PM",
    color: "blue.400",
  },
  {
    logo: FaCreditCard,
    title: "New card added for order #3210145",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
  },
  {
    logo: SiDropbox,
    title: "Unlock packages for Development",
    date: "19 DEC 11:35 PM",
    color: "purple",
  },
  {
    logo: AdobexdLogo,
    title: "New order #9851258",
    date: "18 DEC 4:41 PM",
  },
];

export const timelineProjectsData = [
  {
    logo: FaBell,
    title: "$2400, Design changes",
    titleColor: "#fff",
    date: "22 DEC 7:20 PM",
    color: "blue.500",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "blue.500",
        titleTag: "DESIGN",
      },
    ],
  },
  {
    logo: FaHtml5,
    title: "New order #4219423",
    titleColor: "#fff",
    date: "21 DEC 11:21 PM",
    color: "red.500",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "red.500",
        titleTag: "ORDER",
      },
      {
        bgTag: "red.500",
        titleTag: "#1832412",
      },
    ],
  },
  {
    logo: FaShoppingCart,
    title: "Server Payments for April",
    titleColor: "#fff",
    date: "21 DEC 9:28 PM",
    color: "green.400",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "green.400",
        titleTag: "SERVER",
      },
      {
        bgTag: "green.400",
        titleTag: "PAYMENTS",
      },
    ],
  },
  {
    logo: FaCreditCard,
    title: "New card added for order #3210145",
    titleColor: "#fff",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "orange.300",
        titleTag: "CARD",
      },
      {
        bgTag: "orange.300",
        titleTag: "#1832412",
      },
      {
        bgTag: "orange.300",
        titleTag: "PRIORITY",
      },
    ],
  },
  {
    logo: SiDropbox,
    title: "Unlock packages for Development",
    titleColor: "#fff",
    date: "19 DEC 11:35 PM",
    color: "purple.400",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "purple.400",
        titleTag: "DEVELOPMENT",
      },
    ],
  },
  {
    logo: FaBell,
    title: "$2400, Design changes",
    titleColor: "#fff",
    date: "22 DEC 7:20 PM",
    color: "green.400",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "green.400",
        titleTag: "DESIGN",
      },
    ],
  },
  {
    logo: FaHtml5,
    title: "New order #4219423",
    titleColor: "#fff",
    date: "21 DEC 11:21 PM",
    color: "orange",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "red.500",
        titleTag: "ORDER",
      },
      {
        bgTag: "red.500",
        titleTag: "#1832412",
      },
    ],
  },
  {
    logo: FaShoppingCart,
    title: "Server Payments for April",
    titleColor: "#fff",
    date: "21 DEC 9:28 PM",
    color: "blue.400",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "blue.400",
        titleTag: "SERVER",
      },
      {
        bgTag: "blue.400",
        titleTag: "PAYMENTS",
      },
    ],
  },
  {
    logo: FaCreditCard,
    title: "New card added for order #3210145",
    titleColor: "#fff",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
    description:
      "People care about how you see the world, how you think, what motivates you, what you’re struggling with or afraid of.",
    tags: [
      {
        bgTag: "orange.300",
        titleTag: "CARD",
      },
      {
        bgTag: "orange.300",
        titleTag: "#1832412",
      },
      {
        bgTag: "orange.300",
        titleTag: "PRIORITY",
      },
    ],
  },
];

export const rtlDashboardTableData = [
  {
    logo: AdobexdLogo,
    name: "نسخة Argon UI",
    members: [avatar1, avatar2, avatar3, avatar4, avatar5],
    budget: "$14,000",
    progression: 60,
  },
  {
    logo: AtlassianLogo,
    name: "إضافة مسار التقدم",
    members: [avatar3, avatar2],
    budget: "$3,000",
    progression: 10,
  },
  {
    logo: SlackLogo,
    name: "إصلاح أخطاء النظام الأساسي",
    members: [avatar10, avatar4],
    budget: "غير مضبوط",
    progression: 100,
  },
  {
    logo: SpotifyLogo,
    name: "إطلاق تطبيق الهاتف المحمول الخاص بنا",
    members: [avatar2, avatar3, avatar7, avatar8],
    budget: "$32,000",
    progression: 100,
  },
  {
    logo: JiraLogo,
    name: "أضف صفحة التسعير الجديدة",
    members: [avatar10, avatar3, avatar7, avatar2, avatar8],
    budget: "$400",
    progression: 25,
  },
  {
    logo: InvisionLogo,
    name: "إعادة تصميم متجر جديد على الإنترنت",
    members: [avatar9, avatar3, avatar2],
    budget: "$7,600",
    progression: 40,
  },
];

export const rtlTimelineData = [
  {
    logo: FaBell,
    title: "$2400, تغييرات في التصميم",
    date: "22 DEC 7:20 PM",
    color: "blue.500",
  },
  {
    logo: FaHtml5,
    title: "طلب جديد #4219423",
    date: "21 DEC 11:21 PM",
    color: "orange",
  },
  {
    logo: FaShoppingCart,
    title: "مدفوعات الخادم لشهر أبريل",
    date: "21 DEC 9:28 PM",
    color: "blue.400",
  },
  {
    logo: FaCreditCard,
    title: "تمت إضافة بطاقة جديدة للطلب #3210145",
    date: "20 DEC 3:52 PM",
    color: "orange.300",
  },
  {
    logo: SiDropbox,
    title: "فتح الحزم من أجل التنمية",
    date: "19 DEC 11:35 PM",
    color: "purple",
  },
  {
    logo: AdobexdLogo,
    title: "طلب جديد #9851258",
    date: "18 DEC 4:41 PM",
  },
];

export const tablesTableData = [
  {
    logo: avatar1,
    name: "Esthera Jackson",
    email: "alexa@simmmple.com",
    subdomain: "Manager",
    domain: "Organization",
    status: "Online",
    date: "14/06/21",
  },
  {
    logo: avatar2,
    name: "Alexa Liras",
    email: "laurent@simmmple.com",
    subdomain: "Programmer",
    domain: "Developer",
    status: "Offline",
    date: "12/05/21",
  },
  {
    logo: avatar3,
    name: "Laurent Michael",
    email: "laurent@simmmple.com",
    subdomain: "Executive",
    domain: "Projects",
    status: "Online",
    date: "07/06/21",
  },
  {
    logo: avatar4,
    name: "Freduardo Hill",
    email: "freduardo@simmmple.com",
    subdomain: "Manager",
    domain: "Organization",
    status: "Online",
    date: "14/11/21",
  },
  {
    logo: avatar5,
    name: "Daniel Thomas",
    email: "daniel@simmmple.com",
    subdomain: "Programmer",
    domain: "Developer",
    status: "Offline",
    date: "21/01/21",
  },
  {
    logo: avatar7,
    name: "Mark Wilson",
    email: "mark@simmmple.com",
    subdomain: "Designer",
    domain: "UI/UX Design",
    status: "Offline",
    date: "04/09/20",
  },
];

export const tablesProjectData = [
  {
    logo: AdobexdLogo,
    name: "Argon UI Version",
    budget: "$14,000",
    status: "Working",
    progression: 60,
  },
  {
    logo: AtlassianLogo,
    name: "Add Progress Track",
    budget: "$3,000",
    status: "Canceled",
    progression: 10,
  },
  {
    logo: SlackLogo,
    name: "Fix Platform Errors",
    budget: "Not set",
    status: "Done",
    progression: 100,
  },
  {
    logo: SpotifyLogo,
    name: "Launch our Mobile App",
    budget: "$32,000",
    status: "Done",
    progression: 100,
  },
  {
    logo: JiraLogo,
    name: "Add the New Pricing Page",
    budget: "$400",
    status: "Working",
    progression: 25,
  },
];

export const invoicesData = [
  {
    date: "March, 01, 2020",
    code: "#MS-415646",
    price: "$180",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "February, 10, 2020",
    code: "#RV-126749",
    price: "$250",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "April, 05, 2020",
    code: "#FB-212562",
    price: "$560",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "June, 25, 2019",
    code: "#QW-103578",
    price: "$120",
    logo: FaFilePdf,
    format: "PDF",
  },
  {
    date: "March, 01, 2019",
    code: "#AR-803481",
    price: "$300",
    logo: FaFilePdf,
    format: "PDF",
  },
];

export const billingData = [
  {
    name: "Oliver Liam",
    company: "Viking Burrito",
    email: "oliver@burrito.com",
    number: "FRB1235476",
  },
  {
    name: "Lucas Harper",
    company: "Stone Tech Zone",
    email: "lucas@stone-tech.com",
    number: "FRB1235476",
  },
  {
    name: "Ethan James",
    company: "Fiber Notion",
    email: "ethan@fiber.com",
    number: "FRB1235476",
  },
];

export const newestTransactions = [
  {
    name: "Netflix",
    date: "27 March 2022, at 12:30 PM",
    price: "- $2,500",
    logo: FaArrowDown,
  },
  {
    name: "Apple",
    date: "27 March 2022, at 12:30 PM",
    price: "+ $2,500",
    logo: FaArrowUp,
  },
];

export const olderTransactions = [
  {
    name: "Stripe",
    date: "26 March 2022, at 13:45 PM",
    price: "+ $800",
    logo: FaArrowUp,
  },
  {
    name: "HubSpot",
    date: "26 March 2022, at 12:30 PM",
    price: "+ $1,700",
    logo: FaArrowUp,
  },
  {
    name: "Webflow",
    date: "26 March 2022, at 05:00 PM",
    price: "Pending",
    logo: AiOutlineExclamation,
  },
  {
    name: "Microsoft",
    date: "25 March 2022, at 16:30 PM",
    price: "- $987",
    logo: FaArrowDown,
  },
];

export const transactionsCRM = [
  {
    name: "Netflix",
    date: "26 March 2022, at 13:45 PM",
    price: "- $2500",
    logo: FaArrowDown,
  },
  {
    name: "Apple",
    date: "26 March 2022, at 12:30 PM",
    price: "+ $2500",
    logo: FaArrowUp,
  },
  {
    name: "Stripe",
    date: "26 March 2022, at 05:00 PM",
    price: "+ $9900",
    logo: FaArrowUp,
  },
];

export const revenueCRM = [
  {
    name: "via Paypal",
    date: "27 March 2022, at 12:30 PM",
    price: "+ $8700",
    logo: FaArrowUp,
  },
  {
    name: "Partner #01424",
    date: "27 March 2022, at 12:30 PM",
    price: "+ $12000",
    logo: FaArrowUp,
  },
  {
    name: "Services",
    date: "26 March 2022, at 10:10 PM",
    price: "- $1900",
    logo: FaArrowDown,
  },
];

export const tablesReportsData = [
  {
    image: avatar4,
    domain: "Manager",
    name: "Esthera Jackson",
    review: "Positive",
    email: "esthera@simmmple.com",
    employed: "14/06/21",
    id: 42312,
  },
  {
    image: avatar1,
    domain: "Programmer",
    name: "Alexa Liras",
    review: "Positive",
    email: "alexa@simmmple.com",
    employed: "14/06/21",
    id: 93201,
  },
  {
    image: avatar5,
    domain: "Executive",
    name: "Laurent Michael",
    review: "Neutral",
    email: "laurent@simmmple.com",
    employed: "14/06/21",
    id: 84120,
  },
  {
    image: avatar4,
    domain: "Manager",
    name: "Freduardo Hill",
    review: "Positive",
    email: "freduardo@simmmple.com",
    employed: "14/06/21",
    id: 42314,
  },
  {
    image: avatar7,
    domain: "Programmer",
    name: "Daniel Thomas",
    review: "Negative",
    email: "daniel@simmmple.com",
    employed: "14/06/21",
    id: 75642,
  },
  {
    image: avatar8,
    domain: "Designer",
    name: "Mark Wilson",
    review: "Positive",
    email: "mark@simmmple.com",
    employed: "14/06/21",
    id: 78583,
  },
];

export const rooms = [
  { name: "Living Room", color: "#F687B3", percentage: 15 },
  { name: "Kitchen", color: "#76E4F7", percentage: 18 },
  { name: "Attic", color: "#3182CE", percentage: 23 },
  { name: "Garage", color: "#3182CE", percentage: 35 },
  { name: "Basement", color: "#F6AD55", percentage: 14 },
];

export const pageVisits = [
  {
    pageName: "/argon/",
    visitors: "4,569",
    uniqueUsers: 340,
    bounceRate: "46,53%",
  },
  {
    pageName: "/argon/index.html",
    visitors: "3,985",
    uniqueUsers: 319,
    bounceRate: "46,53%",
  },
  {
    pageName: "/argon/charts.html",
    visitors: "3,513",
    uniqueUsers: 294,
    bounceRate: "36,49%",
  },
  {
    pageName: "/argon/tables.html",
    visitors: "2,050",
    uniqueUsers: 147,
    bounceRate: "50,87%",
  },
  {
    pageName: "/argon/profile.html",
    visitors: "1,795",
    uniqueUsers: 190,
    bounceRate: "46,53%",
  },
];

export const socialTraffic = [
  {
    referral: "Facebook",
    visitors: "1,480",
    percentage: 60,
    color: "orange",
  },
  {
    referral: "Facebook",
    visitors: "5,480",
    percentage: 70,
    color: "orange",
  },
  {
    referral: "Google",
    visitors: "4,807",
    percentage: 80,
    color: "cyan",
  },
  {
    referral: "Instagram",
    visitors: "3,678",
    percentage: 75,
    color: "cyan",
  },
  {
    referral: "Twitter",
    visitors: "2,645",
    percentage: 30,
    color: "orange",
  },
];

export const classRoomList = [
  {
    classroom: "ชั้นเรียนทดสอบ 1",
    gradeLevel: "ม.1",
    year: "2023",
    semester: "1",
    classCode: "AX22G",
    email: "suksomwang@gmail.com"
  },
  {
    classroom: "ชั้นเรียนทดสอบ 2",
    gradeLevel: "ม.2",
    year: "2023",
    semester: "1",
    classCode: "LX22G",
    email: "jirapa@gmail.com"
  },
  {
    classroom: "ชั้นเรียนทดสอบ 3",
    gradeLevel: "ม.3",
    year: "2023",
    semester: "1",
    classCode: "EX22G",
    email: "sukjai@gmail.com"
  },
  {
    classroom: "ชั้นเรียนทดสอบ 4",
    gradeLevel: "ม.4",
    year: "2023",
    semester: "1",
    classCode: "DX22G",
    email: "wongwiwat@gmail.com"
  },
  {
    classroom: "ชั้นเรียนทดสอบ 5",
    gradeLevel: "ม.5",
    year: "2023",
    semester: "1",
    classCode: "CX22G",
    email: "mongkol@gmail.com"
  },
  {
    classroom: "ชั้นเรียนทดสอบ 6",
    gradeLevel: "ม.6",
    year: "2023",
    semester: "1",
    classCode: "VX22G",
    email: "supichaya@gmail.com"
  },
];

export const gradeBookList = [
  [
    {
      value: "ลำดับ",
      readOnly: true
    },
    { value: "ชุดกิจกรรม" },
    { value: "กิจกรรม" },
    { value: "งาน" },
    { value: "w t" },
  ],
  [
      { value: 1 },
      { value: "3.1 สัญลักษณ์แบบจุดของลิวอิสและกฎออกเตต" },
      { value: "สัญลักษณ์แบบจุดของลิวอิสและกฎออกเตต" },
      { value: "วีดิทัศน์การสอน เรื่อง สัญลักษณ์แบบจุดของลิวอิสและกฎออกเตต" },
      { value: "-" }
    ],
    [
      { value: 2 },
      { value: "3.1 สัญลักษณ์แบบจุดของลิวอิสและกฎออกเตต" },
      { value: "สัญลักษณ์แบบจุดของลิวอิสและกฎออกเตต" },
      { value: "test" },
      { value: 3 }
    ],
    /*[
      { value: 3 },
      { value: "ภาณุวัฒน์" },
      { value: "พุกน้อย" },
      { value: 14 },
      { value: 14 },
    ],
    [
      { value: 4 },
      { value: "ยศธร" },
      { value: "รอดเทียม" },
      { value: 14 },
      { value: 14 },
    ],
    [
      { value: 5 },
      { value: "ธนวัฒน์" },
      { value: "รุ่นแรก" },
      { value: 16 },
      { value: 16 },
    ],
    [
      { value: 3 },
      { value: "วิรุธ" },
      { value: "พุกน้อย" },
      { value: 14 },
      { value: 14 },
    ],
    [
      { value: 4 },
      { value: "ยอดศร" },
      { value: "รอดเทียม" },
      { value: 14 },
      { value: 14 },
    ],
    [
      { value: 5 },
      { value: "กลิ่นชาติ" },
      { value: "รุ่นแรก" },
      { value: 16 },
      { value: 16 },
    ],
    [
      { value: 5 },
      { value: "ภูริศ" },
      { value: "เลิศรส" },
      { value: 16 },
      { value: 16 },
    ],*/
];

export const studentList = [
  {
    code: "232",
    name: "สุวิมล เพียงพอ",
    email: "suvimol@gmail.com"
  },
  {
    code: "233",
    name: "ประภากร สุขใจ",
    email: "prapakorn@hotmail.com"
  },
  {
    code: "234",
    name: "ศุภชัย มีความสุข",
    email: "supachai@yahoo.com"
  },
  {
    code: "235",
    name: "ธนวิชญ์ สุขสมบูรณ์",
    email: "thanawich@hotmail.com"
  },
  {
    code: "236",
    name: "สมชาย อุดมสุข",
    email: "somchai@gmail.com"
  },
  {
    code: "237",
    name: "วิริยะ ชื่นใจ",
    email: "wiriya@hotmail.com"
  },
  {
    code: "238",
    name: "กันต์พงศ์ สุขใจ",
    email: "kanpong@gmail.com"
  },
  {
    code: "239",
    name: "ณัฐพงษ์ ศรีเพ็ญ",
    email: "nattapong@yahoo.com"
  },
  {
    code: "240",
    name: "ธนพล เรียนรู้",
    email: "thanapol@gmail.com"
  },
  {
    code: "241",
    name: "อภิสิทธิ์ ทำงานดี",
    email: "apisit@hotmail.com"
  }
];


export const examListData = [
  {
    name: "แบบทดสอบ 1",
    gradeLevel: "ม.1",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 2",
    gradeLevel: "ม.2",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 3",
    gradeLevel: "ม.3",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 4",
    gradeLevel: "ม.4",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 5",
    gradeLevel: "ม.5",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 6",
    gradeLevel: "ม.6",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 7",
    gradeLevel: "ม.5",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 8",
    gradeLevel: "ม.6",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 9",
    gradeLevel: "ม.5",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 10",
    gradeLevel: "ม.6",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 11",
    gradeLevel: "ม.5",
    subject: "ฟิสิกส์"
  },
  {
    name: "แบบทดสอบ 12",
    gradeLevel: "ม.6",
    subject: "ฟิสิกส์"
  },
];

export const bookListData = [
  {
    name: "หนังสือเล่ม 1",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 2",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 3",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 4",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 5",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 6",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 7",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 8",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 9",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 10",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 11",
    subject: "ฟิสิกส์"
  },
  {
    name: "หนังสือเล่ม 12",
    subject: "ฟิสิกส์"
  },
];

export const youtubeData = [
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 1 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=d3SKEOWZzSc",
    thumbnail: "https://img.youtube.com/vi/d3SKEOWZzSc/hqdefault.jpg",
    youtubeID: "d3SKEOWZzSc",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาความสัมพันธ์ตามเงื่อนไขที่กำหนดให้ 2. หาผลคูณคาร์ทีเซียนของเซตที่กำหนดให้ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 2 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=WCSV4v8IUHg",
    thumbnail: "https://img.youtube.com/vi/WCSV4v8IUHg/hqdefault.jpg",
    youtubeID: "WCSV4v8IUHg",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. เขียนกราฟของความสัมพันธ์ 2. หาโดเมนและเรนจ์ของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 3 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=K38TD1OCwv8",
    thumbnail: "https://img.youtube.com/vi/K38TD1OCwv8/hqdefault.jpg",
    youtubeID: "K38TD1OCwv8",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 4 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=nJZV3w6T-YE",
    thumbnail: "https://img.youtube.com/vi/nJZV3w6T-YE/hqdefault.jpg",
    youtubeID: "nJZV3w6T-YE",
    status: "published",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 5 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=rAtSHoIHShk",
    thumbnail: "https://img.youtube.com/vi/rAtSHoIHShk/hqdefault.jpg",
    youtubeID: "rAtSHoIHShk",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 6 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=vPX8OfD4mF0",
    thumbnail: "https://img.youtube.com/vi/vPX8OfD4mF0/hqdefault.jpg",
    youtubeID: "vPX8OfD4mF0",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 7 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=FLKkXIYRmZg",
    thumbnail: "https://img.youtube.com/vi/FLKkXIYRmZg/hqdefault.jpg",
    youtubeID: "FLKkXIYRmZg",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
  {
    title: "ความสัมพันธ์และฟังก์ชัน ตอน 8 (คณิตศาสตร์เพิ่มเติม ม.4 เล่ม 2 บทที่ 1)",
    subject: "คณิตศาสตร์มัธยมศึกษา",
    year: "ม.4",
    duration: "15:30",
    vdoLink: "https://www.youtube.com/watch?v=xwt4F9QbCvs",
    thumbnail: "https://img.youtube.com/vi/xwt4F9QbCvs/hqdefault.jpg",
    youtubeID: "xwt4F9QbCvs",
    status: "draft",
    description: "เมื่อนักเรียนชมวีดิทัศน์นี้แล้ว นักเรียนสามารถ 1. หาตัวผกผันของความสัมพันธ์ 2. เขียนกราฟของตัวผกผันของความสัมพันธ์ วีดิทัศน์นี้จัดทำขึ้นภายใต้โครงการ Project14 ของ สสวท. ดูรายละเอียดเพิ่มเติมได้ที่ http://proj14.ipst.ac.th"
  },
];

export const questionData = {
  "ResponseFixedRandomTestset": {
      "RequestedName": "airun",
      "RequestedNo": "",
      "RequestType": "1",
      "TestSetType": "FI",
      "ErrorMessage": "000,จำนวนข้อสอบในชุดทั้งหมด 3 ข้อ",
      "TestSetTotalItem": 3,
      "ResponseTestsetGroup_ResponseFixedRandomTestset": {
          "ResponseTestsetGroup": {
              "TestSetID": "FI00186593",
              "TestSubset1ID": "",
              "TestSubset2ID": "",
              "TotalItems": 3,
              "ResponseItemGroup_ResponseTestsetGroup": {
                  "ResponseItemGroup": [
                    {
                      "ItemSeq": 1,
                      "ItemID": "191010038",
                      "QuestionType": "SA",
                      "ItemQuestion": "ถ้า a มากกว่า 7 อยู่ &ndash;2 &nbsp;และ b น้อยกว่า a อยู่ &ndash;6 &nbsp;แล้ว &nbsp;b เท่ากับเท่าใด<br />\n&nbsp;",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br />a มากกว่า 7 อยู่ &ndash;2 &nbsp;หมายความว่า&nbsp; a &ndash; 7 = &ndash;2 &nbsp;<br />\nจะได้ &nbsp;a = 5<br />\nb น้อยกว่า a อยู่ &ndash;6 &nbsp;หมายความว่า&nbsp; a &ndash; b = &ndash;6<br />\nจะได้&nbsp; 5 &ndash; b = &ndash;6<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5 + 6 = b<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; b = 11<br />\n<u>ตรวจสอบ</u> ถ้า a = 5 &nbsp;และ&nbsp; b = 11<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; จะได้ว่า 5 มากกว่า 7 อยู่ &ndash;2<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; และ &nbsp;&nbsp;11 น้อยกว่า 5 อยู่ &ndash;6<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; ซึ่งเป็นจริง<br />\nดังนั้น &nbsp;b เท่ากับ 11<br />\n&nbsp;",
                      "CreatedDate": "2019-08-16T07:51:11+00:00",
                      "LastModifiedDate": "2019-09-10T08:41:48+00:00",
                      "Lessons": "247",
                      "Indicators": "[{\"code\":\"60 ค 1.3 ม.1/1\", \"name\":\"เข้าใจและใช้สมบัติของการเท่ากันและสมบัติของจำนวน เพื่อวิเคราะห์และ แก้ปัญหาโดยใช้สมการเชิงเส้นตัวแปรเดียว\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemShortAnswer_ResponseItemGroup": {
                        "Unit": "",
                        "ItemShortAnswer": [
                          {
                            "ItemAnswerSeq": 1,
                            "ItemAnswer": "11",
                            "ItemAnswerType": "number",
                            "ItemAnswerOperation": null
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 2,
                      "ItemID": "181014030",
                      "QuestionType": "SA",
                      "ItemQuestion": "ข้อมูลแสดงระยะทางที่รถยนต์สองคันวิ่งได้ ณ เวลาต่าง ๆ เป็นดังกราฟ<br />\n&nbsp; &nbsp;<img alt=\"\" height=\"261\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/12481.jpg\" width=\"437\" /><br />\nจากกราฟ&nbsp; ในระยะทาง 200 กิโลเมตร&nbsp; อัตราเร็วเฉลี่ยของรถยนต์สองคันนี้ต่างกันกี่กิโลเมตรต่อชั่วโมง",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br /><img alt=\"\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/41945.jpg\" />",
                      "CreatedDate": "2016-06-30T04:02:53+00:00",
                      "LastModifiedDate": "2019-10-07T04:24:25+00:00",
                      "Lessons": "249",
                      "Indicators": "[{\"code\":\"60 ค 1.3 ม.1/2\", \"name\":\"เข้าใจและใช้ความรู้เกี่ยวกับกราฟในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemShortAnswer_ResponseItemGroup": {
                        "Unit": "กิโลเมตรต่อชั่วโมง",
                        "ItemShortAnswer": [
                          {
                            "ItemAnswerSeq": 1,
                            "ItemAnswer": "15",
                            "ItemAnswerType": "number",
                            "ItemAnswerOperation": null
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 3,
                      "ItemID": "191010057",
                      "QuestionType": "MC",
                      "ItemQuestion": "แบ่งรูปสี่เหลี่ยมออกเป็นช่องตารางที่มีขนาดเท่ากัน 16 ช่อง&nbsp; และระบายสีช่องตารางไว้บางส่วน ดังรูป<br />\n&nbsp;&nbsp; &nbsp;&nbsp; <img alt=\"\" height=\"130\" src=\"https://otims.ipst.ac.th/storage/images/1688849860270752_p6_3.jpg\" width=\"130\" /><br />\nจากรูป&nbsp; อัตราส่วนของพื้นที่ส่วนที่ระบายสีต่อพื้นที่ทั้งหมดเป็นเท่าใด",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br /><img alt=\"\" height=\"189\" src=\"https://otims.ipst.ac.th/storage/images/1688849860270752_MA Su 3.jpg\" width=\"451\" />",
                      "CreatedDate": "2019-08-23T03:32:20+00:00",
                      "LastModifiedDate": "2019-09-21T03:22:39+00:00",
                      "Lessons": "248",
                      "Indicators": "[{\"code\":\"60 ค 1.1 ม.1/3\", \"name\":\"เข้าใจและประยุกต์ใช้อัตราส่วน สัดส่วน และร้อยละ ในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemChoice_ResponseItemGroup": {
                        "ItemChoice": [
                          {
                            "ItemChoiceSeq": 1,
                            "ItemChoice": "1 : 1",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 2,
                            "ItemChoice": "1 : 2",
                            "ItemChoiceKey": "True"
                          },
                          {
                            "ItemChoiceSeq": 3,
                            "ItemChoice": "2 : 1",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 4,
                            "ItemChoice": "2 : 3",
                            "ItemChoiceKey": "False"
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 4,
                      "ItemID": "181014432",
                      "QuestionType": "MC",
                      "ItemQuestion": "จำนวนในข้อใดเรียงลำดับจากมากไปน้อย",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br />ตัวเลือกที่ 1, 2&nbsp; และ 3&nbsp; เป็นการเรียงลำดับจำนวนจากน้อยไปมาก<br />\nตัวเลือกที่ 4&nbsp; เป็นการเรียงลำดับจำนวนจากมากไปน้อย&nbsp;<br />\nเพราะ 0 มากกว่า -1 และ -1 มากกว่า -2",
                      "CreatedDate": "2018-02-28T09:28:46+00:00",
                      "LastModifiedDate": "2019-10-15T07:20:56+00:00",
                      "Lessons": "242",
                      "Indicators": "[{\"code\":\"60 ค 1.1 ม.1/1\", \"name\":\"เข้าใจจำนวนตรรกยะและความสัมพันธ์ของจำนวนตรรกยะ และใช้สมบัติ ของจำนวนตรรกยะในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemChoice_ResponseItemGroup": {
                        "ItemChoice": [
                          {
                            "ItemChoiceSeq": 1,
                            "ItemChoice": "3,&nbsp; 4,&nbsp; 5",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 2,
                            "ItemChoice": "-1,&nbsp; 0,&nbsp; 1",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 3,
                            "ItemChoice": "-15,&nbsp; -14,&nbsp; -13",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 4,
                            "ItemChoice": "0,&nbsp; -1,&nbsp; -2",
                            "ItemChoiceKey": "True"
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 5,
                      "ItemID": "181014046",
                      "QuestionType": "SA",
                      "ItemQuestion": "ถังใบหนึ่งมีน้ำอยู่ &nbsp;<span class=\"math-tex\">\\(\\displaystyle{\\frac{2}{5} }\\)</span>&nbsp; ของถัง&nbsp; เมื่อเติมน้ำเพิ่มอีก 20 ลิตร&nbsp; จะได้น้ำครึ่งถังพอดี&nbsp;&nbsp; ถังใบนี้จุน้ำกี่ลิตร",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br /><img alt=\"\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/41970.jpg\" />",
                      "CreatedDate": "2016-06-30T04:34:01+00:00",
                      "LastModifiedDate": "2019-10-15T06:18:36+00:00",
                      "Lessons": "245",
                      "Indicators": "[{\"code\":\"60 ค 1.1 ม.1/1\", \"name\":\"เข้าใจจำนวนตรรกยะและความสัมพันธ์ของจำนวนตรรกยะ และใช้สมบัติ ของจำนวนตรรกยะในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemShortAnswer_ResponseItemGroup": {
                        "Unit": "ลิตร",
                        "ItemShortAnswer": [
                          {
                            "ItemAnswerSeq": 1,
                            "ItemAnswer": "200",
                            "ItemAnswerType": "number",
                            "ItemAnswerOperation": null
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 6,
                      "ItemID": "191010050",
                      "QuestionType": "MA",
                      "ItemQuestion": "กำหนดให้ a, b และ c เป็นจำนวนเต็ม จงจับคู่จำนวนที่เป็นคำตอบของคำถามต่อไปนี้",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br />1. ถ้า a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b = &ndash;7 &nbsp;และ &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c = 4&nbsp; แล้ว &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c)&nbsp; เท่ากับเท่าใด<br />\nจะได้ว่า&nbsp; a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c) = (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c)<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; = (&ndash;7) &ndash; 4<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; = &ndash;11<br />\nดังนั้น&nbsp; a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c) = &ndash;11<br />\n<br />\n2. ถ้า (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) + (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = 24 &nbsp;และ &nbsp;b + c = 4 &nbsp;แล้ว &nbsp;a &nbsp;เท่ากับเท่าใด<br />\nจาก &nbsp;&nbsp;&nbsp;(a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) + (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = 24<br />\nจะได้&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b + c) = 24<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> 4 = 24<br />\nดังนั้น&nbsp; a = 6<br />\n&nbsp;",
                      "CreatedDate": "2019-08-21T06:57:31+00:00",
                      "LastModifiedDate": "2019-09-17T02:09:01+00:00",
                      "Lessons": "242",
                      "Indicators": "[{\"code\":\"60 ค 1.1 ม.1/1\", \"name\":\"เข้าใจจำนวนตรรกยะและความสัมพันธ์ของจำนวนตรรกยะ และใช้สมบัติ ของจำนวนตรรกยะในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemMatchingChoice_ResponseItemGroup": {
                        "ItemMatchingChoice": [
                          {
                            "ItemRightSideSeq": 1,
                            "ItemRightSide": "-28"
                          },
                          {
                            "ItemRightSideSeq": 2,
                            "ItemRightSide": "-11"
                          },
                          {
                            "ItemRightSideSeq": 3,
                            "ItemRightSide": "-3"
                          },
                          {
                            "ItemRightSideSeq": 4,
                            "ItemRightSide": "6"
                          },
                          {
                            "ItemRightSideSeq": 5,
                            "ItemRightSide": "20"
                          },
                          {
                            "ItemRightSideSeq": 6,
                            "ItemRightSide": "28"
                          }
                        ]
                      },
                      "ItemMatchingQuestion_ResponseItemGroup": {
                        "ItemMatchingQuestion": [
                          {
                            "ItemLeftSideSeq": 1,
                            "ItemLeftSide": "1. &nbsp;ถ้า a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b = &ndash;7 &nbsp;และ &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c = 4&nbsp; แล้ว &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c)&nbsp; เท่ากับเท่าใด",
                            "ItemRightSideKey": 2
                          },
                          {
                            "ItemLeftSideSeq": 2,
                            "ItemLeftSide": "2. &nbsp;ถ้า (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) + (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = 24 &nbsp;และ &nbsp;b + c = 4 &nbsp;แล้ว &nbsp;a &nbsp;เท่ากับเท่าใด",
                            "ItemRightSideKey": 4
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 7,
                      "ItemID": "181014044",
                      "QuestionType": "MC",
                      "ItemQuestion": "&ldquo;ถ้านำ 3 คูณกับผลบวกของ x กับ 42 ได้ผลลัพธ์เป็น 312 แล้วค่าของ x เท่ากับเท่าใด&rdquo;&nbsp;&nbsp; เขียนสมการเพื่อหาค่าของ x&nbsp; ได้ดังข้อใด",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br /><img alt=\"\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/41967.jpg\" />",
                      "CreatedDate": "2016-06-30T04:30:51+00:00",
                      "LastModifiedDate": "2019-10-15T06:19:37+00:00",
                      "Lessons": "247",
                      "Indicators": "[{\"code\":\"60 ค 1.3 ม.1/3\", \"name\":\"เข้าใจและใช้ความรู้เกี่ยวกับความสัมพันธ์เชิงเส้นในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemChoice_ResponseItemGroup": {
                        "ItemChoice": [
                          {
                            "ItemChoiceSeq": 1,
                            "ItemChoice": "<p>3(x + 42) = 312</p>",
                            "ItemChoiceKey": "True"
                          },
                          {
                            "ItemChoiceSeq": 2,
                            "ItemChoice": "<p>3x + 42 = 312</p>",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 3,
                            "ItemChoice": "<p>3(x + 312) = 42</p>",
                            "ItemChoiceKey": "False"
                          },
                          {
                            "ItemChoiceSeq": 4,
                            "ItemChoice": "<p>3x + 312 = 42</p>",
                            "ItemChoiceKey": "False"
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 8,
                      "ItemID": "191010052",
                      "QuestionType": "MA",
                      "ItemQuestion": "จงจับคู่สมการกับข้อความต่อไปนี้",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br />1. &nbsp;a บวกด้วย 8 เท่ากับ 2&nbsp;<br />\nเขียนสมการได้ดังนี้&nbsp; a + 8 = 2<br />\n<br />\n2. &nbsp;a บวกด้วย 2 เท่ากับ 8 เท่าของ a<br />\nเขียนสมการได้ดังนี้&nbsp; a + 2 = 8a<br />\n<br />\n4. &nbsp;2 เท่าของ a ลบด้วย 3 เท่ากับ 2 เท่าของผลต่างของ 8 กับ a<br />\nเขียนสมการได้ดังนี้&nbsp; 2a &ndash; 3 = 2(a - 8)<br />\n<br />\n3.&nbsp; แบ่งลูกอม 8 เม็ด ให้คน a คน ได้คนละ 3 เม็ด แล้วเหลือลูกอม 2 เม็ด<br />\nดังนั้น&nbsp; 8 &ndash; 3a = 2<br />\n&nbsp;",
                      "CreatedDate": "2019-08-21T07:08:29+00:00",
                      "LastModifiedDate": "2019-09-17T02:15:35+00:00",
                      "Lessons": "247",
                      "Indicators": "[{\"code\":\"60 ค 1.3 ม.1/1\", \"name\":\"เข้าใจและใช้สมบัติของการเท่ากันและสมบัติของจำนวน เพื่อวิเคราะห์และ แก้ปัญหาโดยใช้สมการเชิงเส้นตัวแปรเดียว\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemMatchingChoice_ResponseItemGroup": {
                        "ItemMatchingChoice": [
                          {
                            "ItemRightSideSeq": 1,
                            "ItemRightSide": "a + 2 = 8a"
                          },
                          {
                            "ItemRightSideSeq": 2,
                            "ItemRightSide": "a + 8 = 2"
                          },
                          {
                            "ItemRightSideSeq": 3,
                            "ItemRightSide": "8 + 3a = 2"
                          },
                          {
                            "ItemRightSideSeq": 4,
                            "ItemRightSide": "8 - 3a = 2"
                          },
                          {
                            "ItemRightSideSeq": 5,
                            "ItemRightSide": "2a - 3 = 2a - 8"
                          },
                          {
                            "ItemRightSideSeq": 6,
                            "ItemRightSide": "2a - 3 = 2(a - 8)"
                          }
                        ]
                      },
                      "ItemMatchingQuestion_ResponseItemGroup": {
                        "ItemMatchingQuestion": [
                          {
                            "ItemLeftSideSeq": 1,
                            "ItemLeftSide": "1. &nbsp;a บวกด้วย 8 เท่ากับ 2&nbsp;",
                            "ItemRightSideKey": 2
                          },
                          {
                            "ItemLeftSideSeq": 2,
                            "ItemLeftSide": "2. &nbsp;a บวกด้วย 2 เท่ากับ 8 เท่าของ a",
                            "ItemRightSideKey": 1
                          },
                          {
                            "ItemLeftSideSeq": 3,
                            "ItemLeftSide": "3. &nbsp;2 เท่าของ a ลบด้วย 3 เท่ากับ 2 เท่าของผลลบของ a ลบด้วย 8",
                            "ItemRightSideKey": 6
                          },
                          {
                            "ItemLeftSideSeq": 4,
                            "ItemLeftSide": "4. &nbsp;แบ่งลูกอม 8 เม็ด ให้นักเรียน a คน ได้คนละ 3 เม็ด แล้วเหลือลูกอม 2 เม็ด",
                            "ItemRightSideKey": 4
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 9,
                      "ItemID": "191010049",
                      "QuestionType": "MA",
                      "ItemQuestion": "กำหนดให้ a, b และ c เป็นจำนวนเต็ม จงจับคู่จำนวนที่เป็นคำตอบของข้อความต่อไปนี้",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br />1. ถ้า a = &ndash;5 &nbsp;และ &nbsp;b &ndash; c = 3 &nbsp;แล้ว &nbsp;(a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) &nbsp;เท่ากับเท่าใด<br />\nจะได้ว่า&nbsp; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c)<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; = (&ndash;5) <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> 3<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; = &ndash;15<br />\nดังนั้น&nbsp; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> (b &ndash; c) = &ndash;15<br />\n<br />\n2. ถ้า a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b = 3 &nbsp;และ &nbsp;(b &ndash; c) <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> a = &ndash;11&nbsp; แล้ว &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c &nbsp;เท่ากับเท่าใด<br />\nจาก&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (b &ndash; c) <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> a = &ndash;11<br />\nจะได้&nbsp; (b <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> a) &ndash; (c <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> a) = &ndash;11<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = &ndash;11<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3 &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) = &ndash;11<br />\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3 + 11 = a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c<br />\nดังนั้น&nbsp; a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c = 14<br />\n&nbsp;",
                      "CreatedDate": "2019-08-21T06:47:25+00:00",
                      "LastModifiedDate": "2019-09-17T02:07:00+00:00",
                      "Lessons": "242",
                      "Indicators": "[{\"code\":\"60 ค 1.1 ม.1/1\", \"name\":\"เข้าใจจำนวนตรรกยะและความสัมพันธ์ของจำนวนตรรกยะ และใช้สมบัติ ของจำนวนตรรกยะในการแก้ปัญหาคณิตศาสตร์และปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 1\", \"name\":\"จำนวนและพีชคณิต\"}]",
                      "ItemMatchingChoice_ResponseItemGroup": {
                        "ItemMatchingChoice": [
                          {
                            "ItemRightSideSeq": 1,
                            "ItemRightSide": "-33"
                          },
                          {
                            "ItemRightSideSeq": 2,
                            "ItemRightSide": "-15"
                          },
                          {
                            "ItemRightSideSeq": 3,
                            "ItemRightSide": "-8"
                          },
                          {
                            "ItemRightSideSeq": 4,
                            "ItemRightSide": "-2"
                          },
                          {
                            "ItemRightSideSeq": 5,
                            "ItemRightSide": "8"
                          },
                          {
                            "ItemRightSideSeq": 6,
                            "ItemRightSide": "14"
                          }
                        ]
                      },
                      "ItemMatchingQuestion_ResponseItemGroup": {
                        "ItemMatchingQuestion": [
                          {
                            "ItemLeftSideSeq": 1,
                            "ItemLeftSide": "1. ถ้า a = &ndash;5 &nbsp;และ &nbsp;b &ndash; c = 3 &nbsp;แล้ว &nbsp;(a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b) &ndash; (a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c) &nbsp;เท่ากับเท่าใด",
                            "ItemRightSideKey": 2
                          },
                          {
                            "ItemLeftSideSeq": 2,
                            "ItemLeftSide": "2. ถ้า a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> b = 3 &nbsp;และ &nbsp;(b &ndash; c) <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> a = &ndash;11&nbsp; แล้ว &nbsp;a <span class=\"math-tex\">\\(\\displaystyle{\\times }\\)</span> c &nbsp;เท่ากับเท่าใด",
                            "ItemRightSideKey": 6
                          }
                        ]
                      }
                    },
                    {
                      "ItemSeq": 10,
                      "ItemID": "181014093",
                      "QuestionType": "SA",
                      "ItemQuestion": "พิจารณาการสร้างมุม TMA ดังรูปต่อไปนี้<br />\n&nbsp; &nbsp; &nbsp;<img alt=\"\" height=\"155\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/12458.jpg\" width=\"275\" /><br />\nถ้าต้องการแบ่งมุม AMV ออกเป็น 4 มุมที่มีขนาดเท่ากัน&nbsp; แล้วแต่ละมุมมีขนาดกี่องศา",
                      "SuggestedTime": "2.0",
                      "Explanation": "<br /><br />\n<img alt=\"\" src=\"https://otimsfileserver.ipst.ac.th/otims/prd/file-upload/41492.jpg\" />",
                      "CreatedDate": "2016-06-30T07:43:00+00:00",
                      "LastModifiedDate": "2019-09-25T09:10:45+00:00",
                      "Lessons": "243",
                      "Indicators": "[{\"code\":\"60 ค 2.2 ม.1/1\", \"name\":\"ใช้ความรู้ทางเรขาคณิตและเครื่องมือ เช่น วงเวียนและสันตรง รวมทั้งโปรแกรม The Geometer’s Sketchpad หรือ โปรแกรมเรขาคณิตพลวัตอื่น ๆ เพื่อสร้างรูปเรขาคณิต ตลอดจนนำความรู้เกี่ยวกับการสร้างนี้ไปประยุกต์ใช้ในการแก้ปัญหาในชีวิตจริง\"}]",
                      "Strands": "[{\"code\":\"60 ค 2\", \"name\":\"การวัดและเรขาคณิต\"}]",
                      "ItemShortAnswer_ResponseItemGroup": {
                        "Unit": "องศา",
                        "ItemShortAnswer": [
                          {
                            "ItemAnswerSeq": 1,
                            "ItemAnswer": "30",
                            "ItemAnswerType": "number",
                            "ItemAnswerOperation": null
                          }
                        ]
                      }
                    }
                  ]
              }
            }
          }
        }
      }